// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Exzhp","login__contact":"styles_login__contact__YATc8"};